var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotVerify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NOT_verify",
    "data-name": "NOT verify",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NOT_verify-2",
    "data-name": "NOT verify"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27756",
    "data-name": "Path 27756",
    d: "M17,31A14,14,0,1,1,31,17,14,14,0,0,1,17,31ZM17,5.154A11.846,11.846,0,1,0,28.846,17,11.846,11.846,0,0,0,17,5.154Z",
    transform: "translate(-3 -3)",
    fill: "#ff7878"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37964",
    "data-name": "Group 37964",
    transform: "translate(12.752 6.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1340",
    d: "M12.248,310.882A1.248,1.248,0,0,1,11,309.634V300.9a1.248,1.248,0,0,1,2.5,0v8.736A1.248,1.248,0,0,1,12.248,310.882Z",
    transform: "translate(-11 -299.65)",
    fill: "#ff7878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1342",
    d: "M13.5,297.9a1.248,1.248,0,1,0-1.248,1.248A1.248,1.248,0,0,0,13.5,297.9Z",
    transform: "translate(-11 -283.732)",
    fill: "#ff7878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerify);
export default __webpack_public_path__ + "static/media/not-verify.7a70d6a55048ad50c6942e95eaf4d414.svg";
export { ForwardRef as ReactComponent };